import { useCallback, useEffect, useState } from 'react';

import { type ReportsConfig } from '../../common/types';

export const useReportsHomePageController = (reportsConfig: ReportsConfig[]) => {
	const [searchValue, setSearchValue] = useState('');
	const [filteredReportsConfig, setFilteredReportsConfig] =
		useState<ReportsConfig[]>(reportsConfig);

	useEffect(() => {
		setFilteredReportsConfig(reportsConfig);
	}, [reportsConfig, setFilteredReportsConfig]);

	const searchForReport = useCallback(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(event: any) => {
			if (event.type !== 'change') {
				return;
			}
			const value = event.target.value;
			setSearchValue(value);
			let filteredResult = reportsConfig.map((config) => {
				const searchResults = { ...config };
				searchResults.reports = config.reports.filter((report) =>
					report.title.toLowerCase().includes(value.toLowerCase()),
				);
				return searchResults;
			});
			filteredResult = filteredResult.filter((config) => config.reports.length > 0);
			setFilteredReportsConfig(filteredResult);
		},
		[reportsConfig, setSearchValue, setFilteredReportsConfig],
	);

	return {
		searchForReport,
		searchValue,
		filteredReportsConfig,
	};
};
